import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';

// コンポーネントのインポート
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CompanyInfo from './pages/CompanyInfo';
import NewsArchive from './components/NewsArchive';
import ContactForm from './pages/ContactForm';
import ServicesPage from './pages/ServicesPage';
import AlmCodeLandingPage from './components/AlmCodeLandingPage';
import Harucool from './components/Harucool';
import ProductFeaturePage from './pages/ProductFeaturePage';

// ScrollToTop コンポーネント
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="font-sans text-gray-900">
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
          <title>共伸機工株式会社</title>
          <meta name="description" content="共伸機工株式会社の公式ウェブサイトです。" />
        </Helmet>
        <Header />
        <main>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/company" element={<CompanyInfo />} />
              <Route path="/news" element={<NewsArchive />} />
              <Route path="/products" element={<ProductFeaturePage />} />
              <Route path="/almcode" element={<AlmCodeLandingPage />} />
              <Route path="/products/almcode" element={<AlmCodeLandingPage />} /> 
              <Route path="/services" element={<ServicesPage />} />
              <Route path="products/harucool" element={<Harucool />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

// 404 Not Found ページ
const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-4xl font-bold mb-4">404 - ページが見つかりません</h1>
      <p className="text-xl mb-8">お探しのページは存在しないか、移動した可能性があります。</p>
      <a href="/" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
        ホームに戻る
      </a>
    </div>
  );
};

export default App;